/**
 * @generated SignedSource<<5fd8cd75a90e64d1d0a120fe684bac2e>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type BookmarkButtonContentUsageFragment$data = {
  readonly hasViewerBookmarked: boolean;
  readonly id: string;
  readonly " $fragmentType": "BookmarkButtonContentUsageFragment";
};
export type BookmarkButtonContentUsageFragment$key = {
  readonly " $data"?: BookmarkButtonContentUsageFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"BookmarkButtonContentUsageFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "BookmarkButtonContentUsageFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "hasViewerBookmarked",
      "storageKey": null
    }
  ],
  "type": "ContentUsage",
  "abstractKey": null
};

(node as any).hash = "dfa42ee2b72d035649840770f64f1e16";

export default node;
